import React, { useEffect, useRef } from "react";
import { CrossIcon } from "../../../SvgIcons/allIcons";

const TextField = ({
  element,
  preview,
  setItem,
  handleChange,
  handleRemoveObject,
  setSelectedElement,
  selectedElement,
}) => {
  const textareaRef = useRef(null);
  const isWrappedTextField =
    element.key === "nutritionalInfo" &&
    ["ingredients", "allergens"].includes(element.childKey);

  let inputProps = {
    onChange: (e) => handleChange(e.target.value, element.id),
    value: element.value || "",
    readOnly: element.readOnly || false,
  };

  const handleInput = () => {
    const textarea = textareaRef.current;
    if (!textarea || !isWrappedTextField) return;
    textarea.style.height = "auto";
    textarea.style.height = `${textarea.scrollHeight}px`;
  };

  useEffect(() => {
    handleInput();
  }, [element.value, isWrappedTextField]);

  return (
    <div
      className="position-relative"
      onClick={() => setSelectedElement(element)}
    >
      {preview ? (
        <div
          className={`label-input-preview ${isWrappedTextField ? "label-input-preview-wrap-inline" : "d-flex gap-1"
            }`}
        >
          {isWrappedTextField ? (
            <p
              className="wrapped-text-inline-preview"
              style={element.input?.style || {}}
            >
              {element.showLabel && (
                <span className="wrapped-label-prefix" style={element.input?.style || {}}>
                  {`${element.labelText}: `}
                </span>
              )}
              {element.value || ""}
            </p>
          ) : (
            <>
              {element.showLabel && (
                <label className="labelMain" {...element.input}>
                  {`${element.labelText}:`}
                </label>
              )}
              <p
                className="commonInput"
                {...element.input}
              >
                {element.value || ""}
              </p>
            </>
          )}
        </div>
      ) : (
        <div className="label-input">
          <span
            className={
              isWrappedTextField ? "label-input-row-wrap" : "d-flex gap-1"
            }
          >
            {element.key == "additionalInfo" &&
              element.childKey == "customFieldValue" ? (
              <>
                <textarea
                  ref={textareaRef}
                  onInput={handleInput}
                  rows={1}
                  style={{
                    overflow: "hidden",
                    resize: "none",
                    ...element.input.style,
                  }}
                  value={element.labelText || ""}
                  onChange={(e) =>
                    setItem((prevItems) =>
                      prevItems.map((item) =>
                        item.id === element.id
                          ? { ...item, labelText: e.target.value }
                          : item
                      )
                    )
                  }
                  className="commonInput"
                  name="taskDate"
                  placeholder={element.placeholder || ""}
                />{" "}
                <p className="labelMain" {...element.input}>
                  :
                </p>
              </>
            ) : isWrappedTextField ? (
              <div className="wrapped-textarea-container" style={element.input?.style || {}}>
                {element.showLabel && (
                  <span className="wrapped-label-prefix" style={element.input?.style || {}}>
                    {`${element.labelText}: `}
                  </span>
                )}
                <textarea
                  ref={textareaRef}
                  onInput={handleInput}
                  rows={1}
                  style={{
                    overflow: "hidden",
                    resize: "none",
                    whiteSpace: "pre-wrap",
                    overflowWrap: "anywhere",
                    wordBreak: "break-word",
                    display: "inline",
                    ...element.input.style,
                  }}
                  className="commonInput wrapped-text-value"
                  name="taskDate"
                  placeholder={element.placeholder || ""}
                  {...inputProps}
                />
              </div>
            ) : (
              element.showLabel && (
                <p className="labelMain" {...element.input}>
                  {`${element.labelText}:`}
                </p>
              )
            )}
            {!isWrappedTextField && (
              <textarea
                ref={textareaRef}
                onInput={handleInput}
                rows={1}
                style={{
                  overflow: "hidden",
                  resize: "none",
                  whiteSpace: "nowrap",
                  overflowWrap: "normal",
                  wordBreak: "normal",
                  ...element.input.style,
                }}
                className="commonInput"
                name="taskDate"
                placeholder={element.placeholder || ""}
                {...inputProps}
              />
            )}
            {selectedElement?.id == element.id && (
              <span
                className="cross-icon-label ms-1"
                role="button"
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveObject(element.id);
                  setSelectedElement("");
                }}
              >
                <CrossIcon size={13} />
              </span>
            )}
          </span>
        </div>
      )}
    </div>
  );
};

export default TextField;
